import { CreditDetailsScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <CreditDetailsScreen />;
}
